export default class AlertClose {
    constructor($el) {
        this.$el = $el;
        this.$close = this.$el.querySelector('[data-close]');

        this.close = this.close.bind(this);

        this.$close.addEventListener('click', this.close);
    }

    close(e) {
        e.preventDefault();
        this.$el.classList.add('alert--close');
    }
}